// @flow

import Resource from 'speed-js-core/src/api/Resource';

export default class CoverageResource extends Resource {
    basePath: string = 'addresses/coverage/';

    objectPath: string = 'addresses/coverage/{ident}/';

    check(data: Object): Promise<Object> {
        return this.client._request(`${this.basePath}check/`, 'POST', data);
    }

    checkSchema(): Promise<Object> {
        return this.client._request(`${this.basePath}check/`, 'OPTIONS').then((response) => response.data);
    }

    checkCoverage(data: {
        reg_id: string,
        mun_id: string,
        post_code: string,
        town_id: string,
        str_type: string,
        str_name: string,
        str_n: string,
        entr_n: string,
        floor_n: string,
        app_n: string,
    }): Promise<{
        ok: boolean,
        status: number,
        statusText: string,
        headers: Object,
        data: Object,
    }> {
        return this.client._request(`${this.basePath}check/`, 'POST', data);
    }

    checkCoverageResult(executionId: string): Promise<{
        ok: boolean,
        status: number,
        statusText: string,
        headers: Object,
        data: Object,
    }> {
        return this.client._request(`${this.basePath}check_paused/`, 'GET', { execution_id: executionId });
    }

    confirmNotification(executionId: string, confirm: boolean): Promise<{
        ok: boolean,
        status: number,
        statusText: string,
        headers: Object,
        data: Object,
    }> {
        return this.client._request(
            `${this.basePath}confirm_notification/`, 'POST',
            { coverage_notification: confirm, execution_id: executionId },
        );
    }
}
